import { useCallback, useState } from 'react'
import { useToggle } from 'react-use'

import LoadingLayout from '~common/LoadingLayout/LoadingLayout'
import Button from '~elements/Button'
import { useFeedbackPostCommentsQuery } from '~generated/hooks'
import CommentIcon from '~icons/comment.svg'
import Arrow from '~lib/ui-kit/Arrow'
import Collapse from '~lib/ui-kit/Collapse'
import Row from '~lib/ui-kit/Row'
import Space from '~lib/ui-kit/Space'
import FeedbackPostCommentsInput from '~modules/feedbackTool/containers/FeedbackPostCommentsInput'
import FeedbackPostCommentsList from '~modules/feedbackTool/containers/FeedbackPostCommentsList'
import { ReplyToOptions } from '~modules/feedbackTool/utils'

interface FeedbackPostCommentsProps {
  fedbackPostId: string
  className?: string
}

function FeedbackPostComments({ fedbackPostId, className }: FeedbackPostCommentsProps) {
  const [commentsOpened, toggleCommentsOpened] = useToggle(true)
  const [replyToOptions, setReplyToOptions] = useState<ReplyToOptions>(null)

  const handleResetReplyToOptions = useCallback(() => {
    setReplyToOptions(null)
  }, [])

  const { data: { feedbackPost } = {}, loading } = useFeedbackPostCommentsQuery({
    variables: {
      id: fedbackPostId,
    },
  })

  return (
    <div className={className}>
      <Row align="center" gutterX="1" className="mb-2">
        <Space align="center" justify="center">
          <CommentIcon />
        </Space>

        <Button
          variant="plain"
          bold
          onClick={toggleCommentsOpened}
          endIcon={<Arrow as="span" direction={commentsOpened ? 'bottom' : 'right'} />}
        >
          Comments
        </Button>
      </Row>

      <Collapse opened={commentsOpened} unmount>
        <LoadingLayout loading={loading}>
          {feedbackPost?.comments?.length > 0 && (
            <FeedbackPostCommentsList
              comments={feedbackPost?.comments}
              replyingTo={replyToOptions}
              onSetReplyingTo={setReplyToOptions}
              className="mb-2"
            />
          )}
        </LoadingLayout>

        <FeedbackPostCommentsInput
          feedbackPostId={fedbackPostId}
          replyingTo={replyToOptions}
          disabled={loading}
          onResetReplyingTo={handleResetReplyToOptions}
        />
      </Collapse>
    </div>
  )
}

export default FeedbackPostComments
